import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import { getDocuments } from "../../api/kyc";
import { getWordOfDictionary } from "../../common/dictionary";
import { AuthContext } from "../../context/AuthContext";
import FContainer from "../../components/FContainer/FContainer";
import { size } from "lodash";
import FBannerTitle from "../../components/FspendComponents/FBannerSpend/FBannerTitle";

const BasicInformationScreen = () => {
  const { setLoading,checkToken } = useContext(AuthContext);
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    async function gDocuments() {
      checkToken()
      try {
        setLoading(true);
        let resp = await getDocuments();
        setDocuments(resp.data.data);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }

    gDocuments();
  }, []);


  const route = useNavigate();

  return (
    <>
      <FBannerTitle
        title="Mis documentos"
        imageUrl={require("../../components/assets/images/doc.png")}
      />
      <FContainer>
        {documents.map((document, index) => (
          <div className="border-0 mt-10 w-full grid grid-cols-1 sm:grid-cols-2 text-center sm:text-left rounded-xl text-[14px] bg-[#f0f0f0] p-2 shadow-Box">
            <div className="border-0 col-span-1 sm:col-span-2 text-[17px] font-bold py-2">
              {document.typeOfDocument.id == "US_DRIVER_LICENSE" ? "Licencia de conducir US" : null}
              {document.typeOfDocument.id == "MX_DRIVER_LICENSE" ? "Licencia de conducir MX" : null}
              {document.typeOfDocument.id == "US_PASSPORT" ? "Pasaporte US" : null}
              {document.typeOfDocument.id == "MX_PASSPORT" ? "Pasaporte MX" : null}
              {document.typeOfDocument.id == "MX_NATIONAL_ID" ? "Credencial de elector MX" : null}
            </div>
            <div className="border-0 col-span-1 font-bold ">
              Número de identificación:
            </div>
            <div className="border-0 col-span-1 text-[15px] font-medium grid items-center">
              {size(document.documentNumber)
                ? document.documentNumber
                : "No Disponible"}
            </div>
            <div className="border-0 col-span-1 font-bold ">Nombres:</div>
            <div className="border-0 col-span-1 text-[15px] font-medium  grid items-center">
              {`${!document.firstName ? "" : document.firstName} ${!document.middleName ? "" : document.middleName
                }`}
            </div>
            <div className="border-0 col-span-1 font-bold ">Apellidos:</div>
            <div className="border-0 col-span-1 text-[15px] font-medium  grid items-center">
              {`${!document.lastName ? "" : document.lastName} ${!document.maternalLastName ? "" : document.maternalLastName
                }`}
            </div>
            <div className="border-0 col-span-1 font-bold ">
              Estado del documento:
            </div>
            <div className="border-0 col-span-1 text-[15px] font-medium  grid items-center">
              {getWordOfDictionary(document.status)}
            </div>
          </div>
        ))}
        <div className='pt-5 text-Secondary font-bold text-[16px] cursor-pointer' onClick={() => {
            route("/MenuKycScreen");
          }}>
            Agregar un documento
          </div>
      </FContainer>
    </>
  );
};

export default BasicInformationScreen;
